import mealDetailsQuery from './mealDetailsQuery.graphql';
import checkErrors from '../checkErrors';
import { createError } from '../createError';
import createVariables from './createVariables';

// See restaurant-details/fetchData.js: a miss is `{ meal: null }`, not null.
const hasResults = data => data != null && data.meal != null;

const fetchData = ({ client, location }) => {
    return resultsFetchData({ resultsQuery: mealDetailsQuery })({
        client,
        location,
    });
};

const slugRegex = /^(?:.*[-/])?([a-zA-Z0-9-_]+)$/;

const extractMealId = pathname => {
    const matched = slugRegex.exec(pathname);
    return matched ? matched[1] : null;
};

const resultsFetchData =
    ({ resultsQuery }) =>
    ({ client, location, fetchPolicy = 'cache-first' }) => {
        const { pathname } = location;
        const mealId = extractMealId(pathname);

        const searchParams = {
            mealId,
        };

        return (
            client
                .query({
                    query: resultsQuery,
                    variables: createVariables(searchParams),
                    fetchPolicy,
                })
                // Both branches must resolve with a Response: resolveCurrentScreen feeds
                // this straight into responseAsPromise, which calls `.fold` on it. The
                // previous plain `{ data, error }` objects had no `fold`, so every
                // GraphQL error and every network failure surfaced as
                // "TypeError: response.fold is not a function" -> a blanket 500, which
                // is why unknown meals returned 500 instead of 404.
                //
                // checkErrors already prefers data over errors, so a partial success
                // still renders rather than erroring.
                .then(checkErrors(hasResults, 'meal'))
                .catch(createError({ dataBeingFetched: 'meal' }))
        );
    };

// The same fetch (status codes, redirects, error mapping) with another query
// document: the new detail page (W3.1) asks for a few extra fields.
export const fetchDataWithQuery =
    resultsQuery =>
    ({ client, location }) =>
        resultsFetchData({ resultsQuery })({ client, location });

export default fetchData;
